const styles = (theme) => ({
  roundedButton: {
    borderRadius: theme.spacing(4),
  },
})

export default styles
